module.exports = __webpack_public_path__ + "static/img/9.afa8184.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/3/6/zh/9.png
// module id = i/IB
// module chunks = 0